export const OAS_API_BASE_URL = [];

export const SECRET_KEY =
  "7j84kh0+UDWA55erb2uIiyiuFgtF29G1hO3fYFhk+nvJ1PBBD1TMpj/958Ir5bbiCuCvUEw8ojUxuacOJqdnnQ==";

export const ENCR_DECR_KEY = "1576934859612375";
